import { Box, useTheme } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { ContractorGraph } from "../contractorTypes";

const categories = ["Delivery", "Responsiveness", "Quality"];

export const PerformanceComparison: React.FC<{ data: ContractorGraph }> = ({ data }) => {

  const theme = useTheme();

  const getColor = (label: string) => {
    switch (label) {
      case "East Coast":
        return theme.palette.primary.main;
      case "Norfolk":
        return theme.palette.success.main;
      case "Cambridgeshire":
        return theme.palette.warning.main;
      default:
        return theme.palette.secondary.main;
    }
  }

  const getData = (data: ContractorGraph) => {
    return data.contractors.map((value) => {
      return {
        data: [value.delivery, value.responsiveness, value.quality],
        label: value.contractor_name,
        color: getColor(value.contractor_name),
      };
    })
  };

  return (
    <Box sx={{ width: "100%", p: 3 }}>
      <BarChart
        xAxis={[
          {
            scaleType: "band",
            data: categories,
            tickLabelStyle: { fontSize: 12 },
            height: 30,
          },
        ]}
        yAxis={[
          {
            tickLabelStyle: { fontSize: 12 },
            min: 0,
            max: 100,
          },
        ]}
        series={getData(data)}
        height={300}
        slotProps={{
          legend: {
            position: { vertical: "bottom", horizontal: "center" },
          },
        }}
        grid={{ vertical: false, horizontal: true }}
        borderRadius={4}
        margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
      />
    </Box>
  );
};
